import {forwardRef} from 'react';
import {NavLink, NavLinkProps} from 'react-router-dom';

type AnchorLinkProps = Omit<NavLinkProps, 'to'> & { href: NavLinkProps['to'] };

export const AnchorLink = forwardRef<HTMLAnchorElement, AnchorLinkProps>(({
    href, ...props
}, ref) => {
    return (
        <NavLink
            ref={ref}
            to={href}
            {...props}
        />
    );
});

AnchorLink.displayName = 'AnchorLink';
